import { getStorage } from './storage'

/**
 * 判断是否有权限
 * @param {string} key //权限标识关键字
 */
export function isAuth (key) {
  return (getStorage('userAuth') || '[]').indexOf(key) !== -1 || false
}
